import { IUser } from 'types';

import { UserQuery } from 'queries';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';

interface Props {
  user: IUser;
  handleOff?: () => void;
}

function useUserStatus({ user, handleOff }: Props) {
  const { mutate } = UserQuery.usePut();

  const handleChagneStatus = (status: IUser['status']) => {
    mutate(
      { id: user.id, status },
      {
        onSettled: () => {
          handleOff?.();
        },
        onSuccess: () => {
          const msg =
            status === 'BLOCK'
              ? '이용이 정지 되었습니다'
              : '이용정지가 해제되었습니다';
          toast.success(`${user.name}님의 ${msg}`);
        },
        onError: () => toast.error(DEFAULT_ERROR_MESSAGE),
      },
    );
  };

  return { handleChagneStatus };
}

export default useUserStatus;
